import { render, staticRenderFns } from "./configuration.vue?vue&type=template&id=4537f671&scoped=true&"
import script from "./configuration.vue?vue&type=script&lang=js&"
export * from "./configuration.vue?vue&type=script&lang=js&"
import style0 from "./configuration.vue?vue&type=style&index=0&id=4537f671&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4537f671",
  null
  
)

export default component.exports